/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   Not really a memoizer, since it doesn't consider the inputs per-se.
 * But if a selector creates new objects/arrays and returns them, it will remember the
 * previous return value and re-use it if it is deep-equal to the new return value (to
 * prevent components that take the return value as a prop from re-rendering).
 */

import deepEqual from 'fast-deep-equal'

import { Selector } from './types'

export const memoizeDeepReturnValue = <Args extends any[], Result>(
  selector: Selector<Args, Result>
): Selector<Args, Result> => {
  let lastResult: Result | undefined
  return (...args: Args) => {
    const result = selector(...args)
    if (lastResult && deepEqual(lastResult, result)) {
      return lastResult
    }
    lastResult = result
    return result
  }
}
